import { Empty, Space } from 'antd'
import { RecordType } from 'app/constants/GlobalTypes'
import { ToolBox } from 'app/lib/hooks/toolBox'
import React from 'react'

import { MemberProps } from '../convention'
import RentalRedirectionButton from '../Rental/RedirectionButton'

type Props = {
  messageType: 'invalid' | 'accepted'
}

const QuoteFeedbackInvalid: React.FC<MemberProps<IQuote, Props>> = ({
  member,
  props: { messageType }
}) => {
  const { tComponent } = ToolBox.useString()
  return (
    <Empty
      description={
        <Space direction="vertical">
          <p>
            {tComponent({
              recordType: RecordType.quote_feedback,
              componentName: 'empty',
              componentType: 'core',
              id: messageType
            })}
          </p>
          <RentalRedirectionButton rentalId={member?.rental_id} />
        </Space>
      }
    />
  )
}

export default QuoteFeedbackInvalid
